export default function Header() {
  return (
    <header className="text-center mt-3">
      <img src="/images/banner.png" alt="banner" style={{ width: '100%' }} />
    </header>
  );
}
